import { render, staticRenderFns } from "./topicResult.vue?vue&type=template&id=f05f92dc&scoped=true&"
import script from "./topicResult.vue?vue&type=script&lang=js&"
export * from "./topicResult.vue?vue&type=script&lang=js&"
import style0 from "./topicResult.vue?vue&type=style&index=0&id=f05f92dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05f92dc",
  null
  
)

export default component.exports